import React from 'react';
import PropTypes from "prop-types";

const ModalDeleteChapter = ({ hideModalDelete, showModalDeleteChapter, removeChapterConfirmation, chapterId}) => {
    return(
        <div
            className={`bootbox modal fade bootbox-confirm ${showModalDeleteChapter && "in"}`}
            tabIndex="-1"
            role="dialog"
            style={{
                display: showModalDeleteChapter ? "block": "none",
                paddingRight: 15
            }}
        >
            <div className="modal-dialog modal-md">
                <div className="modal-content">
                    <div className="modal-body">
                        <button
                            type="button"
                            className="bootbox-close-button close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            style={{marginTop: -10}}
                            onClick={() => hideModalDelete()}
                        >
                            ×
                        </button>
                        <div className="bootbox-body">
                            <div className="sp-10 font-16">
                                Do you really want to remove this chapter?<br /><br />
                                This will also delete all chapter content associated with this chapter.  This action is irreversable, which is why we're asking you to confirm your action.
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            data-bb-handler="cancel"
                            type="button"
                            className="btn btn-default"
                            onClick={() => hideModalDelete()}
                        >
                            CANCEL
                        </button>
                        <button
                            data-bb-handler="confirm"
                            type="button"
                            className="btn btn-danger"
                            onClick={() =>
                            {
                                hideModalDelete();
                                removeChapterConfirmation(chapterId);
                            }
                            }
                        >
                            DELETE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ModalDeleteChapter.propTypes = {
    showModalDeleteChapter: PropTypes.bool,
    hideModalDelete: PropTypes.func.isRequired,
    removeChapterConfirmation: PropTypes.func.isRequired,
    chapterId: PropTypes.any.isRequired
};

export default ModalDeleteChapter;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/ModalDeleteChapter.js